import CallServer from '../../api/CallServerV2';
import FileServer from '../../api/FileServer'
export async function fetchGetFolder (params = {}) {
    return await CallServer({
        endpoint: '/admin/get_folder',
        params: params,
        needAuthenticate: true,
        isGet: true,
        retryIfFailed: true
    })
} 

export async function fetchCreateTraining (params = {}, exam_data) {
    return await CallServer({
        body  :exam_data,
        params: params,
        endpoint: '/admin/add_training_to_folder',
    })
} 

export async function fetchAddQuestions (exam_id,training_data) {
    return await CallServer({
        params: {
            exam_id: exam_id
        },
        body  :training_data,
        endpoint: '/admin/add_new_training_questions',
    })
} 

export async function fetchDownloadQuestions (exam_id) {
    return await FileServer({
        params: {
            exam_id: exam_id
        },
        isGet: true,
        endpoint: '/admin/download_training_questions_to_excel',
    })
} 